import me from "models/me";
import { getStore } from "store";

export default function (module) {
    return function (nextState, replace, callback) {
        const { scope } = getStore().getState();
        if (!me.canViewBrand()) {
            replace({
                pathname: "/profile",
            });
            callback();
        } else if (me.account_type === "nuorder") {
            callback();
        } else if (scope.brand && scope.brand.available_modules.indexOf(module) === -1) {
            replace({
                pathname: "/404",
            });
            callback();
        } else {
            callback();
        }
    };
}
